import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/index';
import { Input, Button } from 'antd'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { apiAccountLogin, apiGetPage } from '../../request/api'
import { useCustomData } from '../../pages/context/loginCustomDataProvider';

interface loginInfo {
    loginName?: string;
    email?: string;
    phone?: string;
    password?: string;
    verification?: string;
    account?: string;
    emailError?: string;
    phoneError?: string;
    accountError?: string;
    passwordError?: string;
    verificationError?: string;
    enterAccount?: string;
    enterEmail?: string;
    enterPassword?: string;
    enterPasswordAgain?: string;
    enterVerification?: string;
    enterPhone?: string;
    forget?: string;
    getBack?: string;
    next?: string;
    check1?: string;
    verifyIdentity?: string;
    resetPassword?: string;
    orInfo?: string;
    backLogin?: string;
    seccond?: string;
    changeInfo?: string;
    sendVerification?: string;
    verifyIdentityFor?: string;
    sendIdentifying?: string;
}

interface AcountLoginProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
const AcountLogin: React.FC<AcountLoginProps> = ({ handleViewChange, data }) => {
    const navigate = useNavigate();
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [error, setError] = useState<string | null>(null);
    const [isHovered, setIsHovered] = useState(false);
    const [password, setPassword] = useState('')
    const { getValue, customData } = useCustomData();
    const [loginInfo, setLoginInfo] = useState<loginInfo>({
        loginName: "", email: "", phone: "", password: "", verification: "", account: "", emailError: "", sendVerification: "",
        phoneError: "", accountError: "", passwordError: "", verificationError: "", enterAccount: "", enterEmail: "",
        enterPassword: "", enterPasswordAgain: "", enterVerification: "", enterPhone: "", forget: "", verifyIdentityFor: "",
        getBack: "", next: "", check1: "", verifyIdentity: "", resetPassword: "", orInfo: "", backLogin: "", seccond: "", changeInfo: "",
        sendIdentifying: ''
    });

    useEffect(() => {
        if (customData.length === 0) return; // 数据还没来
        const newLoginInfo: loginInfo = {
            loginName: getValue('loginName'),
            email: getValue('email'),
            phone: getValue('phone'),
            password: getValue('password'),
            verification: getValue('verification'),
            account: getValue('account'),
            emailError: getValue('emailError'),
            phoneError: getValue('phoneError'),
            accountError: getValue('accountError'),
            passwordError: getValue('passwordError'),
            verificationError: getValue('verificationError'),
            enterAccount: getValue('enterAccount'),
            enterEmail: getValue('enterEmail'),
            enterPassword: getValue('enterPassword'),
            enterPasswordAgain: getValue('enterPasswordAgain'),
            enterVerification: getValue('enterVerification'),
            enterPhone: getValue('enterPhone'),
            forget: getValue('forget'),
            getBack: getValue('getBack'),
            next: getValue('next'),
            check1: getValue('check1'),
            verifyIdentity: getValue('verifyIdentity'),
            resetPassword: getValue('resetPassword'),
            orInfo: getValue('orInfo'),
            backLogin: getValue('backLogin'),
            seccond: getValue('seccond'),
            changeInfo: getValue('changeInfo'),
        };
        setLoginInfo(newLoginInfo);
    }, [customData]);

    const backToLoginPage = () => {
        handleViewChange('mainLogin', data.acount)
    }

    const changePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        const pass = e.target.value
        setPassword(pass)
        // 移除实时验证，仅保留状态更新
        setError(null) // 清除之前的错误提示
    }

    const loginIn = () => {
        // 新增提交时的验证逻辑
        if (password.length < 6) {
            setError('密码不得小于6位');
            return; // 阻止继续执行
        }

        apiAccountLogin({
            accountName: data.acount,
            password: password,
        }, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            const token = res.data.data.token;
            localStorage.setItem('userToken', token);
            localStorage.setItem('userName', res.data.data.name);
            localStorage.setItem('userId', res.data.data.accountId);
            localStorage.setItem('userPhone', res.data.data.phone);
            localStorage.setItem('userEmail', res.data.data.email);
            console.log(localStorage.getItem('userToken'))
            navigate('/mine')
            // 根据响应处理登录结果
        }).catch(err => {
            // 处理错误
            console.error('登录失败:', err);
            setError('登录失败，请重试');
        });
    };

    const toAcountVerification = () => {
        handleViewChange('loadAccount', data.acount)
    }
    return (
        <div>
            <div className='login-header'>{loginInfo.loginName}</div>
            <div className='login-body'>
                <span>{data.acount}</span>
                <span onClick={backToLoginPage} className='cursur' style={{ color: themeColor, cursor: 'pointer' }}>{loginInfo.changeInfo}</span>
            </div>
            <div className='login-body_header'>{loginInfo.password}</div>
            <Input.Password
                status={error ? 'error' : ''}
                placeholder={loginInfo.enterPassword}
                value={password}
                onChange={changePassword}
            />
            {error && (
                <div style={{ color: '#e60d0d', marginTop: '2px', fontSize: '12px' }}>
                    {error}
                </div>
            )}
            <Button type="primary" onClick={loginIn}>{loginInfo.loginName}</Button>
            <div className='login-bottom'
                style={{
                    color: isHovered ? themeColor : "inherit"
                }}
                onClick={toAcountVerification}
                onMouseEnter={() => { setIsHovered(true) }}
                onMouseLeave={() => { setIsHovered(false) }}
            >{loginInfo.forget}?</div>
        </div>
    )

};

export default AcountLogin;
